export const MAX_CODE_LENGTH = 6
export const POST_VERIFY_DELAY = 1000
